// 旧アンケート回答済み（displayNameなし）→ クリアして再回答
// LP2回答済み + purchaseCTAClicked → クリアして再回答
// LP2回答済み（purchaseCTAClickedなし）→ 結果ページにリダイレクト
const hasAnswerData =
  localStorage.getItem("workerData") &&
  localStorage.getItem("scoreArray") &&
  localStorage.getItem("tasteType") &&
  localStorage.getItem("workerType");

if (hasAnswerData) {
  const isOldQuestionnaire = !localStorage.getItem("displayName");
  const shouldClearData = isOldQuestionnaire || localStorage.getItem("purchaseCTAClicked");

  if (shouldClearData) {
    localStorage.removeItem('purchaseCTAClicked');
    localStorage.removeItem('workerData');
    localStorage.removeItem('scoreArray');
    localStorage.removeItem('tasteType');
    localStorage.removeItem('workerType');
    localStorage.removeItem('displayName');
    localStorage.removeItem('allergies');
  } else {
    window.location.href = "/pages/cocoro-hitoiki-worker-type-questionnaire-lp2-result";
  }
} else {
  // 回答データがなくてもpurchaseCTAClickedが残っている可能性があるのでクリア
  localStorage.removeItem('purchaseCTAClicked');
}

const startButton = document.getElementById("startBtn");
const nextButton = document.getElementById("nextBtn");
const backButton = document.getElementById("backBtn");
const backButtonConfirm = document.getElementById("backBtnConfirm");
const wtQuestionnaireTop = document.getElementById("questionnaireTop");
const wtQuestionnaireContainer = document.getElementById(
  "questionnaireContainer",
);
const wtQuestionnaireConfirm = document.getElementById("confirmContainer");
const questionTitle = document.getElementById("questionTitle");
const questionChoice = document.getElementById("questionChoice");
const answerButtons = document.getElementById("answerButtons");
let redoBtn = document.querySelectorAll(".wt-questionnaire__redo-btn");
let scoreArray = {};
let allergyArray = [];
let displayName = "";

const formatQuestionTitle = (text) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>")
    .replace(/（[^）]*）/g, '<span class="wt-questionnaire__question-sub">$&</span>');
let questionIndex = 0;
let redoFlg = false;
let transitionTimer = null;

startButton.addEventListener("click", () => {
  window.scroll({
    top: 0,
  });
  wtQuestionnaireTop.classList.add("hide");
  wtQuestionnaireConfirm.classList.add("hide");
  wtQuestionnaireContainer.classList.remove("hide");
  showQuestion(); // 選択肢表示
  nextButton.setAttribute("data-question-index", questionIndex);
});

// 次へボタンをクリック
nextButton.addEventListener("click", () => {
  window.scroll({
    top: 0,
  });

  pushAnswer(); //選択した回答を配列に格納
  changePage(); // ページの切り替え
  updatePageNumber(); // ページ番号更新
  nextButton.setAttribute("data-question-index", questionIndex);

  if (
    questionIndex < questions.length - 1 &&
    !checkScoreArray()
  ) {
    nextButtonChange(); //次へボタンアクティブ非アクティブ化
  }
});

// 戻るボタンをクリック
backButton.addEventListener("click", () => {
  redoFlg = false;

  if (questionIndex === 0) {
    wtQuestionnaireTop.classList.remove("hide");
    wtQuestionnaireContainer.classList.add("hide");
    resetState();
    return;
  }

  questionIndex--;
  resetState();
  showQuestion();
  nextButtonChange();
});

// 戻るボタンをクリック(確認ページ)
backButtonConfirm.addEventListener("click", () => {
  wtQuestionnaireConfirm.classList.add("hide");
  wtQuestionnaireContainer.classList.remove("hide");

  questionIndex = questions.length - 1; // 最後の設問（お名前入力）に戻る
  resetState();
  showQuestion();
});

// 確認画面の修正ボタンをクリック
redoBtn.forEach((button, index) => {
  button.addEventListener("click", () => {
    redoFlg = true;
    wtQuestionnaireConfirm.classList.add("hide");
    wtQuestionnaireContainer.classList.remove("hide");
    resetState();
    questionIndex = index;
    showQuestion();
  });
});

function showQuestion() {
  updatePageNumber();
  addClassMeter();

  const currentQuestion = questions[questionIndex];

  // お名前入力の場合
  if (currentQuestion.type === "name-input") {
    questionTitle.innerHTML = formatQuestionTitle(currentQuestion.question);
    questionChoice.innerText = currentQuestion.questionChoice;
    questionChoice.classList.remove('wt-questionnaire__question-choice--multiple');

    const inputContainer = document.createElement("div");
    inputContainer.classList.add("wt-questionnaire__text-input-container");

    const input = document.createElement("input");
    input.type = "text";
    input.id = "display-name-input";
    input.classList.add("wt-questionnaire__text-input");
    input.placeholder = "お名前を入力";
    input.value = displayName;
    input.setAttribute("oninput", "nextButtonChange()");

    inputContainer.appendChild(input);
    answerButtons.appendChild(inputContainer);
    nextButtonChange();
    return;
  }

  mainContent();

  if (currentQuestion.type === "allergy") {
    const noAllergyAnswer = currentQuestion.answers.find(
      (answer) => answer.name === "該当なし",
    );
    if (!noAllergyAnswer) {
      return;
    }
    const noAllergyCheckbox = document.getElementById(
      "answer-" + noAllergyAnswer.key,
    );
    if (!noAllergyCheckbox) {
      return;
    }

    // すべてのアレルギー項目を取得（"該当なし"を除外）
    const allCheckboxes = Array.from(document.querySelectorAll('.answer-input'))
        .filter(checkbox => checkbox.id !== noAllergyCheckbox.id);

    // 初期状態で "該当なし" がチェックされていた場合、他のアレルギー項目を無効化
    if (noAllergyCheckbox.checked) {
      noAllergyCheckbox.disabled = true;
    }

    // "該当なし"がチェックされたときの処理
    noAllergyCheckbox.addEventListener('change', () => {
      if (noAllergyCheckbox.checked) {
        // "該当なし"が◯に変更された場合、他の全てのアレルゲンを未選択にする
        allCheckboxes.forEach(chk => {
          chk.checked = false;  // 他の項目を未選択にする
        });
        // 該当なしがチェックされたら、それを操作できないようにする
        noAllergyCheckbox.disabled = true;
      } else {
        // "該当なし"が✗にされた場合、操作可能にする
        noAllergyCheckbox.disabled = false;
      }
    });

    // 他のアレルゲン項目が変更されたときの処理
    allCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          // 他のアレルゲンが選択された場合、「該当なし」を✗にする
          noAllergyCheckbox.checked = false;
          noAllergyCheckbox.disabled = false; // 該当なしの項目を操作可能にする
        }

        // すべてのアレルギー項目が未選択なら、"該当なし" を自動で選択
        const noneSelected = allCheckboxes.every(chk => !chk.checked);
        if (noneSelected) {
          noAllergyCheckbox.checked = true;
          noAllergyCheckbox.disabled = true;
          nextButtonChange();
        }
      });
    });
  }
}

// 表示切り替え
function changePage() {
  if (!redoFlg) {
    gtag('event', 'click', {
      event_category: 'cocoro_hitoiki_worker_type_questionnaire',
      event_label: 'next',
      value: questionIndex + 1,
    });
  }

  const currentQuestion = questions[questionIndex];

  // 修正ボタンからの遷移 または 最後の設問（名前入力）の場合 → 確認画面へ
  if (redoFlg || currentQuestion.type === "name-input") {
    resetState();
    showConfirm();
    return;
  }

  // アレルギー設問の場合、確認ダイアログ
  if (currentQuestion.type === "allergy") {
    if (allergyArray.length === 0) {
      if (window.confirm("アレルギーの項目が選択されていませんが、アレルギー該当なしでよろしいですか？")) {
        allergyArray.push("none");
      } else {
        return;
      }
    }
  }

  // 次の設問へ
  questionIndex++;
  resetState();
  showQuestion();
}

// 回答が全て揃っているかをチェックする
function checkScoreArray() {
  return questions
    .filter((question) => question.type !== "allergy" && question.type !== "name-input")
    .every((question) => scoreArray[question.key]);
}

function mainContent() {
  const currentQuestion = questions[questionIndex];
  const isAllergy = currentQuestion.type === "allergy";

  // タイトル
  questionTitle.innerHTML = formatQuestionTitle(currentQuestion.question);

  // タイトル下
  questionChoice.innerText = currentQuestion.questionChoice;
  if (currentQuestion.multiple) {
    questionChoice.classList.add('wt-questionnaire__question-choice--multiple');
  } else {
    questionChoice.classList.remove('wt-questionnaire__question-choice--multiple');
  }

  // 画像付き回答があるかチェック
  const hasImageAnswers = currentQuestion.answers.some((answer) => answer.image);
  if (hasImageAnswers) {
    answerButtons.classList.add("wt-questionnaire__answer-buttons--with-image");
  } else {
    answerButtons.classList.remove("wt-questionnaire__answer-buttons--with-image");
  }

  // 設問
  currentQuestion.answers.forEach((answer) => {
    const label = document.createElement("label");

    // 画像付き回答の場合は別クラスを使用
    if (answer.image) {
      label.classList.add("wt-questionnaire__answer-button--with-image");
    } else {
      label.classList.add("wt-questionnaire__answer-button");
    }

    const input = document.createElement("input");
    if (questionIndex <= questions.length - 1) {
      input.setAttribute("onchange", "nextButtonChange()");
    }
    input.classList.add("answer-input");
    const key = answer.key;

    // answer-noneの場合にcheckedを付ける
    if (key === 'none') {
      label.classList.add('answer-none');

      // 初期状態または配列内に "none" 以外の値が含まれていない場合にのみ checked を付ける
      if (allergyArray.length === 1 && allergyArray.includes('none')) {
        input.checked = true;
      }
    }

    if (currentQuestion.multiple || isAllergy) {
      input.type = "checkbox";
    } else {
      input.type = "radio";

      // 択一式の場合、選択時に自動遷移
      input.addEventListener("change", () => {
        // 前のタイマーをキャンセル（選択肢変更時のrace condition対策）
        if (transitionTimer) {
          clearTimeout(transitionTimer);
        }
        // 少しの遅延を入れて選択状態を視覚的にフィードバック
        transitionTimer = setTimeout(() => {
          transitionTimer = null;
          window.scroll({ top: 0 });
          pushAnswer();
          changePage();
          updatePageNumber();
          nextButton.setAttribute("data-question-index", questionIndex);
          if (questionIndex < questions.length - 1 && !checkScoreArray()) {
            nextButtonChange();
          }
        }, 350);
      });
    }

    input.name = "answer";
    input.id = "answer-" + key; // input要素にid割り当て
    input.value = key;

    label.setAttribute("for", "answer-" + key); // ラベルと input要素を関連付け

    // ラベルのテキストを追加
    const labelText = document.createTextNode(answer.text);
    const labelTextEight = document.createTextNode(answer.name);
    if (isAllergy) {
      // アレルギーの場合
      const questionsEight = document.createElement("div");
      const ingredients = document.createElement("p");
      questionsEight.classList.add("wt-questionnaire__answer-box");
      questionsEight.appendChild(input);
      questionsEight.appendChild(label);
      ingredients.appendChild(labelTextEight);
      questionsEight.appendChild(ingredients);

      // 要素を追加
      answerButtons.appendChild(questionsEight);
    } else if (answer.image) {
      // 画像付き回答の場合
      const textSpan = document.createElement("span");
      textSpan.classList.add("answer-text");
      textSpan.appendChild(labelText);
      label.appendChild(textSpan);

      const imageDiv = document.createElement("div");
      imageDiv.classList.add("answer-image");
      const img = document.createElement("img");
      // 画像URLを直接使用
      img.src = answer.image;
      img.alt = answer.text;
      imageDiv.appendChild(img);
      label.appendChild(imageDiv);

      // 要素を追加
      answerButtons.appendChild(input);
      answerButtons.appendChild(label);
    } else {
      label.appendChild(labelText);
      // 要素を追加
      answerButtons.appendChild(input);
      answerButtons.appendChild(label);
    }

    // 戻った時にcheck状態を保持
    const scoreKey = currentQuestion.key;
    if (
      (!isAllergy &&
        scoreArray[scoreKey] &&
        scoreArray[scoreKey]["value"].some((answer) => answer.key === key)) ||
      (isAllergy && allergyArray && allergyArray.includes(key))
    ) {
      input.checked = true;
    }
  });

  if (currentQuestion.type === "black-coffee") {
    const note = document.createElement("p");
    note.classList.add("wt-questionnaire__note");
    note.innerHTML = "※飲みたくないを選択した場合、セット内にブラックコーヒーが含まれなくなります。<br>サービス開始後にアンケート回答内容の変更は可能です。";
    answerButtons.appendChild(note);
  }
}

// セグメント式プログレスバーの更新
function addClassMeter() {
  const segments = document.querySelectorAll('.wt-questionnaire__progress-segment');
  const step = questionIndex + 1;
  segments.forEach((segment, index) => {
    if (index < step) {
      segment.classList.add('active');
    } else {
      segment.classList.remove('active');
    }
  });
}

// ページ番号を更新
function updatePageNumber() {
  const pageNumberSpan = document.getElementById("pageNumber");
  if (pageNumberSpan) {
    pageNumberSpan.innerText = `${questionIndex + 1}/${questions.length}`;
  }
}

// 選択した回答を配列に格納
function pushAnswer() {
  const currentQuestion = questions[questionIndex];

  // お名前入力の場合
  if (currentQuestion.type === "name-input") {
    const textInput = document.getElementById("display-name-input");
    if (textInput) {
      displayName = textInput.value.trim();
    }
    return;
  }
  let checkedValues = [];
  let checkedValuesConfirm = [];
  checkedValues = Array.from(document.querySelectorAll("input:checked")).map(
    (input) => parseInt(input.value),
  );
  checkedValuesConfirm = Array.from(
    document.querySelectorAll("input:checked"),
  ).map((input) => input.value);

  if (currentQuestion.type !== "allergy") {
    scoreArray[currentQuestion.key] = {
      title: currentQuestion.question, // 例として仮のタイトルを設定
      value: checkedValues.map((value) => ({
        key: value,
        text: currentQuestion.answers.find((answer) => answer.key === value)
          .text,
        score_active: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_active,
        score_impulse: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_impulse,
        score_stable: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_stable,
        score_careful: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_careful,
        score_behavior_style: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_behavior_style,
        score_work_style: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_work_style,
        score_thinking_type: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_thinking_type,
        score_energy_use: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_energy_use,
        score_pace_control: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_pace_control,
      })),
    };
  } else {
    allergyArray = checkedValuesConfirm;
  }
}

// 次へボタンのアクティブ非アクティブ化
function nextButtonChange() {
  // テキスト入力の場合
  const textInput = document.getElementById("display-name-input");
  if (textInput) {
    nextButton.disabled = textInput.value.trim() === "";
    return;
  }

  let allCheckboxes = document.querySelectorAll(".answer-input");
  let atLeastOneChecked = Array.from(allCheckboxes).some(
    (checkbox) => checkbox.checked,
  );
  nextButton.disabled = !atLeastOneChecked;
}

// 子要素をすべて削除
function resetState() {
  while (answerButtons.firstChild) {
    answerButtons.removeChild(answerButtons.firstChild);
  }
}

// 確認の表示
function showConfirm() {
  wtQuestionnaireContainer.classList.add("hide");
  wtQuestionnaireConfirm.classList.remove("hide");

  const confirmInput = document.querySelectorAll(".confirm-input .answer");
  function extractTextByKey(key, data, isAllergy) {
    let results = [];

    data.forEach((item) => {
      key.forEach((el) => {
        if (item.key === el) {
          results.push(isAllergy ? item.name : item.text);
        }
      });
    });

    return results;
  }

  confirmInput.forEach((el, index) => {
    const currentQuestion = questions[index];

    if (currentQuestion.type === "name-input") {
      el.innerText = displayName;
    } else if (currentQuestion.type === "allergy") {
      el.innerText = extractTextByKey(allergyArray, currentQuestion.answers, true);
    } else {
      const answersVariableKey = scoreArray[currentQuestion.key]["value"].map(
        (answer) => answer.key,
      );
      el.innerText = extractTextByKey(answersVariableKey, currentQuestion.answers, false);
    }
  });
}

const loder = () => {
  const form = document.forms[0];
  const button = form.querySelector(".confirm-button");
  const loader = form.querySelector(".wt-questionnaire__loader");

  button.addEventListener(
    "click",
    (e) => {
      e.preventDefault();

      //ローダーを表示する
      loader.style.display = "block";

      allergyModal();
    },
    false,
  );
};
loder();

const allergyModal = () => {
  const milk = allergyArray.includes("milk");
  const caffeine = allergyArray.includes("caffeine");
  const milkModal = document.querySelector(".wt-questionnaire__modal-milk");
  const caffeineModal = document.querySelector(
    ".wt-questionnaire__modal-coffee",
  );
  const form = document.forms[0];
  const loader = form.querySelector(".wt-questionnaire__loader");

  if (milk && caffeine) {
    milkModal.classList.remove("hide");
    loader.style.display = "none";
    document.body.style.overflow = "hidden";
  } else if (milk) {
    milkModal.classList.remove("hide");
    loader.style.display = "none";
    document.body.style.overflow = "hidden";
  } else if (caffeine) {
    caffeineModal.classList.remove("hide");
    loader.style.display = "none";
    document.body.style.overflow = "hidden";

    const coffeeConfirmButton = document.querySelector(
      ".coffee-confirm-button",
    );
    coffeeConfirmButton.addEventListener("click", () => {
      sendResult();
    });
  } else {
    milkModal.classList.add("hide");
    caffeineModal.classList.add("hide");

    sendResult();
  }
};
function sendResult() {
  const loader = document.querySelector(".wt-questionnaire__loader");
  const wantsBlackCoffee = !!(
    scoreArray["drink-black-coffee"] &&
    scoreArray["drink-black-coffee"].value.some((answer) => answer.key === 1)
  );
  const exclusionKeys = wantsBlackCoffee ? [] : ["black_coffee"];
  const answersPayload = { ...scoreArray };
  delete answersPayload["drink-black-coffee"];

  const minDisplayTime = new Promise((resolve) => setTimeout(resolve, 2000));

  const apiCall = fetch("/apps/cocoro-hitoiki-api/v1/worker_type_answers", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      answers: answersPayload,
      allergies: allergyArray,
      exclusionKeys,
      displayName,
    }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  });

  Promise.all([apiCall, minDisplayTime])
    .then(([data]) => {
      if (data) {
        localStorage.setItem("workerData", JSON.stringify(data));
        localStorage.setItem("workerType", JSON.stringify(data.workerType));
        localStorage.setItem("scoreArray", JSON.stringify(scoreArray));
        localStorage.setItem("tasteType", data.tasteType);
        localStorage.setItem("displayName", displayName);
        localStorage.setItem("allergies", JSON.stringify(allergyArray));

        window.location.href =
          "/pages/cocoro-hitoiki-worker-type-questionnaire-lp2-result";
      } else {
        throw new Error("Network response was not ok");
      }
    })
    .catch(() => {
      loader.style.display = "none";
      showConfirm();
    });
}
